import { useTranslation } from "react-i18next";

export default function CategoryMostUi({ value }) {
  const { t } = useTranslation();

  return (
    <>
      <div className="bg-thirdly rounded-lg p-5 mt-1 h-full">
        {/* Header: Fixed typo and added proper alignment */}
        <div className="flex justify-between items-center mb-5">
          <label className="text-white font-semibold text-xl">
            {t("charts.most_searched_categories")}
          </label>
        </div>

        {/* Content: Used Grid for perfect alignment instead of flex-row */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
          {value?.most_search_categories?.map((category) => (
            <div
              key={category.id}
              className="bg-furthly rounded-md p-3 flex justify-between items-center transition-colors hover:bg-white/20"
            >
              <h2 className="text-white font-medium text-sm truncate pr-2">
                {category.name}
              </h2>
              <span className="text-white bg-secondary font-bold text-xs px-2 py-1 rounded-full min-w-[30px] text-center">
                {category.search_count}
              </span>
            </div>
          ))}
        </div>
      </div>
    </>
  );
}